const SUPER_ADMIN = 'Super Admin'
const MANAGER = 'Manager'
const SYSTEM_USER = 'System User'


export default {
  SUPER_ADMIN,
  MANAGER,
  SYSTEM_USER
}
